export const getTextFromHtml = (htmlString: string): string => {
    if (!htmlString) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent?.trim().replace(/\s+/g, ' ') || '';
};

export const stripHtmlAndGetFirstWords = (htmlString: string, wordCount: number): string => {
    const decoded = getTextFromHtml(htmlString);
    if (!decoded) return '';

    const words = decoded.split(' ');
    return words.slice(0, wordCount).join(' ') + (words.length > wordCount ? '...' : '');
};

export const isContentLong = (htmlString: string, wordLimit: number): boolean => {
    const decoded = getTextFromHtml(htmlString);
    if (!decoded) return false;

    const words = decoded.split(' ');
    return words.length > wordLimit;
};

